import React from 'react'

const Navbar = ( props ) => {
return (
  <nav class="navbar mb-4 navbar-light shadow-sm ml-2 mr-2 mt-2">

  <a class="navbar-brand" href="#"><h3>Sonification Framework for Ireland's Covid-19 Outbreak</h3> <a href ="https://covid19ireland-geohive.hub.arcgis.com/" target="_blank"> <h5 class ="text-wrap">Data from Ireland's COVID-19 Data Hub</h5></a></a>
  </nav>
  )
};

export default Navbar
